import {createAsyncThunk} from "@reduxjs/toolkit";
import {AxiosResponse} from "axios";
import instance from "@/config/axios";
import { getBookingList, getBookingSummary } from '@/store/bookings/action';

export const getBookingDetail = createAsyncThunk('bookingDetail/getBookingDetail',
  async ({ id, success }: { id: string, success: (bookingDetail: BookingDetailState) => void }, {dispatch}) => {
    const url = `v1/bookings/${id}`
    const response: AxiosResponse<BookingDetailState> = await instance.get(url)
    dispatch(getBookingList({}))
    dispatch(getBookingSummary({}))
    success(response.data)
    return response.data
  })

export const editBooking = createAsyncThunk('bookingDetail/editBooking',
  async ({ id, data }: editBookingParam, {dispatch}) => {
    const url = `v1/bookings/${id}`
    const response: AxiosResponse<BookingDetailState> = await instance.patch(url, data)
    dispatch(getBookingList({}))
    dispatch(getBookingSummary({}))
    return response.data
  })
